/**
 * @fileoverview PUT handler for the "/companies/:company_id/oauth_mcp_settings/mcp_enabled" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdOauthMcpSettingsMcpEnabledCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdOauthMcpSettingsMcpEnabledProps,
  PutCompaniesCompanyIdOauthMcpSettingsMcpEnabledResult,
} from "./types";

export const putCompaniesCompanyIdOauthMcpSettingsMcpEnabled = reactQueryMutationAdapter(
  companiesCompanyIdOauthMcpSettingsMcpEnabledCacheKeys,
  (
    props: PutCompaniesCompanyIdOauthMcpSettingsMcpEnabledProps
  ): Promise<PutCompaniesCompanyIdOauthMcpSettingsMcpEnabledResult> => {
    return fetch(
      `/companies/${props.company_id}/oauth_mcp_settings/mcp_enabled`,
      "PUT",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
